// Agents often type a placeholder instead of leaving the field blank, so an
// "empty" concession can reach the UI as "N/A", "none", "-", etc.
const PLACEHOLDER_VALUES = ["n/a", "n/a.", "na", "n.a.", "none", "-", "--"];

export const getRequestedConcessions = (value) => {
  const trimmed = typeof value === "string" ? value.trim() : "";
  return PLACEHOLDER_VALUES.includes(trimmed.toLowerCase()) ? "" : trimmed;
};
